<template>
  <div id="features-one-title">
    <h4 id="feature-one-title" class="feature-one-title-element text-2xl leading-relaxed font-extrabold text-primary-black tracking-tight sm:text-3xl">
      Parimad tehnoloogiad
    </h4>
    <p id="feature-one-description" class="feature-one-title-element mt-2 text-base md:text-lg leading-relaxed font-light text-primary-gray tracking-normal">
      Käime ajaga kaasas luues uudseid lahendusi, et Teie koduleht konkurentsis silma paistaks. Hästi ehitatud
      veebileht aitab suurendada ettevõtte müügitulemusi.
    </p>
  </div>
</template>

<script>
import {gsap} from 'gsap'
export default {
  name: "FeaturesOneTitle",
  methods: {
    animationsInit() {
      const scroller = this.$parent.$parent.$parent.$refs["scrollSections"];
      const trigger = "#features-one-title";
      const scrollTriggerDefaults = {
        trigger: trigger,
        scroller: scroller,
        start: 'top 95%',
        end: "bottom 25%",
      }

      const tl = gsap.timeline({
        scrollTrigger: {
          ...scrollTriggerDefaults
        },
        defaults: {
          y: 0,
          opacity: 1,
          duration: 1,
          ease: 'slow',
          autoAlpha: 1
        }
      });
      tl.to('#feature-one-title', {});
      tl.to('#feature-one-description', {}, 0.3);
    }
  },
  mounted() {
    this.$nextTick(() => {
      const elements = gsap.utils.toArray('.feature-one-title-element')
      elements.forEach(element => {
        gsap.set(element, {
          y: 100,
          opacity: 0,
          autoAlpha: 0
        })
      })

      this.animationsInit()
    })
  }
}
</script>

<style scoped>

</style>
